/* eslint-disable consistent-return */
import config from '@website/config';
import { initializeApp } from 'firebase/app';
import { isSupported, getMessaging, Messaging } from 'firebase/messaging';

const firebaseApp = initializeApp(config.firebase);
export default firebaseApp;

export async function createMessagingInstance(): Promise<
  Messaging | undefined
> {
  // Check if messaging is supported, and do nothing if not
  // This prevents any errors from being thrown
  const supported = await isSupported();
  if (!supported) return;

  // Initialise the messaging instance
  const messaging = getMessaging(firebaseApp);

  return messaging;
}
